import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import logo from 'src/logo.png';

export default function MobileHeader() {
  const history = useHistory();
  const pathname = history?.location?.pathname;
  const [title, setTitle] = useState('');

  useEffect(() => {
    if (!pathname) return;

    const titles = {
      '/personal-property-settlement-form':
        'Application for Settlement or Deferral of Delinquent Property Tax',
      '/personal-property-appeal-form': 'Personal Property Appeal Form for Penalty Reduction',
      '/real-property-appeal-form': 'Real Property Appeal Form for Penalty Reduction',
    };

    setTitle(titles[pathname] || '');
  }, [pathname]);

  return (
    <>
      <div className="flex flex-col items-center sm:hidden">
        <img alt="Utah County Logo" className="mt-3 w-40" src={logo} />
        <div className="mt-5">
          <p className="text-center text-sm font-medium text-black">{title}</p>
        </div>
      </div>
    </>
  );
}
